import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";

declare var alertify:any;
@Component({
  templateUrl:"./badgeGit.html"
})

export class BadgeGit implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService
  ){}

  private data:any=[];
  private imagePath:string='';
  ngOnInit(): void {
    this.getPath();
  }

  private getPath():void{
    this.http.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        this.getData();
      })
  }


  private getData(){
    this.http.getData(API.giftBadge).then(res=>{
      this.data=res.data;
      for (let i=0;i<this.data.length;i++){
        this.data[i].imageEn = this.imagePath+this.data[i].imageEn;
        this.data[i].imageTc = this.imagePath+this.data[i].imageTc;
      }
    });
  }

  private editBadgeGit(id:number){
    this.router.navigate(['index/badgeGit',id]);
  }
  private deleteBadgeGit(id:number):void{
    let _self = this;
    alertify.confirm("删除","確定要刪除嗎？",function () {
      _self.http.deleteData(API.giftBadge+"/"+id).then(res=>{
        if(res.status.code==0){
          alertify.success(res.status.message);
          _self.getData();
        }else {
          alertify.error(res.status.message);
        }
      })
    },function () {

    })
  }


}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/gift/badgeGit.component.ts